import React from "react"

function Spacing() {
  return (
    <div className={"mt-5"} />
  )
}

export default Spacing
